import * as React from "react";

const SvgComponent = ({ fill = "#000", stroke = "#636F7C", ...props }) => (
  <svg
    width={30}
    height={30}
    fill={props.color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <path
      d="M21.769 19.028 16.47 9.85A1.68 1.68 0 0 0 15 9a1.68 1.68 0 0 0-1.472.85L8.23 19.028a1.687 1.687 0 0 0 0 1.7c.306.531.856.85 1.47.85h10.598a1.68 1.68 0 0 0 1.471-.85 1.68 1.68 0 0 0 0-1.7Zm-6.818-7.06a.76.76 0 0 1 .806.805l-.315 4.993v.008a1.23 1.23 0 0 0-.886 0v-.008l-.314-4.994a.758.758 0 0 1 .71-.804ZM15 19.764a.847.847 0 1 1 .002-1.695.847.847 0 0 1-.002 1.695Z"
      fill={fill}
      fillOpacity={1}
    />
  </svg>
);

export default SvgComponent;